module.exports = __webpack_public_path__ + "static/media/B9.ebf4c25b.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/B9.png
// module id = 888
// module chunks = 0